<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <v-dialog
    v-model="dialog"
    persistent
    id="export"
    width="1000px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-card-title class="py-6">
        <div class="text-h6 text-sm-h4">{{ language.t('RoadProfiler.Export.filter') }}</div>
        <v-spacer></v-spacer>
        <v-btn
          icon
          color="blue darken-1"
          @click="$emit('close');"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="py-6">
        <v-container>
          <v-row>
            <v-col style="min-width: 250px;">
              <DateRange
                v-model="daterange"
                :label="language.t('RoadProfiler.Export.dateRange')"
                :hint="language.t('RoadProfiler.Export.dateRangeHint')"
              />
            </v-col>
            <v-col style="min-width: 250px;">
              <DeviceSelect
                v-model="selected_devices"
                :devices="devices"
              />
            </v-col>
            <v-col style="min-width: 250px;">
              <TaskSelect
                v-model="selected_task"
                :tasks="tasks"
                :hint="language.t('RoadProfiler.Export.taskHint')"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="card-actions">
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!selected_task && daterange.length < 1"
          :loading="loading.productionList"
          @click="getProduction"
        >
          <v-icon>mdi-table-search</v-icon>{{ language.t('RoadProfiler.Export.btnView') }}
        </v-btn>
        <v-btn
          :disabled="!selected_task && daterange.length < 1"
          :loading="loading.excel"
          @click="getProductionExcel"
        >
          <v-icon>mdi-file-download</v-icon>{{ language.t('RoadProfiler.Export.btnExcel') }}
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click=" $emit('close');"
        >
          <v-icon>mdi-close</v-icon>{{ language.t('App.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card class="mt-2">
      <v-card-title class="py-6">
        <div class="text-h6 text-sm-h4">{{ language.t('RoadProfiler.Export.production') }}</div>
      </v-card-title>
      <v-card-text>
        <RPRProductionList ref="rprProductionList" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import DeviceSelect from "../formfields/DeviceSelect";
import DateRange from "../formfields/DateRange";
import TaskSelect from "../formfields/TaskSelect";
import RPRProductionList from "./ProductionList";

export default {
  components: {
    DeviceSelect,
    DateRange,
    TaskSelect,
    RPRProductionList,
  },
  props: {},
  data() {
    return {
      devices: [],
      tasks: [],
      dialog: true,
      daterange: [],
      selected_devices: [],
      selected_task: null,
      loading: {
        excel: false,
        productionList: false,
        tasks: false,
        devices: false,
      },
    };
  },
  mounted: function () {
    this.getDevices();
    this.getTasks();
  },
  computed: {},
  watch: {
    selected_devices(val) {
      console.log("device changed: " + val);
    },
    daterange(val) {
      console.log("daterange changed: " + val);
    },
    '$tasks.all'(val) {
      this.tasks = val;
    }
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    getDevices() {
      this.loading.devices = true;
      var _this = this;
      this.$axios.get(route("api.devices")).then((res) => {
        // TODO: check status
        _this.devices = res.data;
        _this.loading.devices = false;
      });
    },
    getTasks() {
      this.tasks = this.$tasks.all;
    },
    getProduction() {
      this.loading.productionList = true;
      if (this.daterange.length < 2) {
        this.$refs.rprProductionList.getProduction(this.selected_devices, this.selected_task, this.daterange[0], null, this.productionLoaded);
      } else {
        var date1 = new Date(this.daterange[0]);
        var date2 = new Date(this.daterange[1]);
        if (date1 < date2) {
          this.$refs.rprProductionList.getProduction(this.selected_devices, this.selected_task, this.daterange[0], this.daterange[1], this.productionLoaded);
        } else {
          this.$refs.rprProductionList.getProduction(this.selected_devices, this.selected_task, this.daterange[1], this.daterange[0], this.productionLoaded);
        }
      }
    },
    productionLoaded() {
      this.loading.productionList = false;
    },
    getProductionExcel() {
      this.loading.excel = true;
      var _this = this;
      var data;
      if (this.daterange.length > 1) {
        var date1 = new Date(this.daterange[0]);
        var date2 = new Date(this.daterange[1]);
        if (date1 < date2) {
          data = { devices: this.selected_devices, task: this.selected_task, startdate: this.daterange[0], enddate: this.daterange[1] };
        } else {
          data = { devices: this.selected_devices, task: this.selected_task, startdate: this.daterange[1], enddate: this.daterange[0] };
        }
      } else {
        data = { devices: this.selected_devices, task: this.selected_task, startdate: this.daterange[0], enddate: null };
      }

      this.$axios.get(route("api.production.rpr.excel"), { params: data, responseType: "blob" }).then((response) => {
        console.log(response);
        // TODO: check status
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;

        if (this.selected_task) {
          var task = this.tasks.find(t => t.taskId === this.selected_task);
          fileLink.setAttribute("download", `${task.name}.xlsx`);
        } else if (this.daterange.length == 2) {
          fileLink.setAttribute("download", `${this.daterange[0]}-${this.daterange[1]}.xlsx`);
        } else {
          fileLink.setAttribute("download", `export.xlsx`);
        }

        document.body.appendChild(fileLink);

        fileLink.click();

        _this.loading.excel = false;
      });
    },
  },
};
</script>

<style scoped>
#export {
  max-width: 1000px;
}
</style>
